export default __webpack_public_path__ + "static/media/product-08 (1).b11d12fb.jpg";